"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("../../atoms/Button/Button"));
var ExportQuizBtn = function (supplier) {
    var getExport = function () {
        var exportUrl = "/api/quiz/export";
        if (supplier.supplier) {
            exportUrl = "/api/quiz/export?supplier=" + supplier.supplier;
        }
        var link = document.createElement('a');
        link.href = exportUrl;
        document.body.append(link);
        link.click();
    };
    var handleClick = function () {
        if (window) {
            var returnValue = window.confirm('Weet je zeker dat je het aanbod wil exporteren?');
            if (returnValue) {
                getExport();
            }
        }
    };
    return (react_1.default.createElement(Button_1.default, { className: "export-btn", onClick: handleClick },
        react_1.default.createElement("span", null, "Export naar excel")));
};
exports.default = ExportQuizBtn;
